var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "m-3", staticStyle: { "max-width": "100vvw" } },
    [
      _c("orm-batch-statistics", {
        attrs: {
          quotes: _vm.combinedBatchedQuotes,
          count: _vm.combinedBatchedQuotes
            ? _vm.combinedBatchedQuotes.length
            : 0,
          alr: _vm.alr,
          "adjusted-alr": _vm.adjustedCombinedAlr,
          "alr-lower-threshold": _vm.innerValue.alrLowerThreshold,
          "alr-upper-threshold": _vm.innerValue.alrUpperThreshold,
          "average-total-ex-gst": _vm.averageTotalExGst,
          "adjusted-total": _vm.adjustedTotal,
          "is-can-edit": _vm.isCanEdit,
        },
        model: {
          value: _vm.value,
          callback: function ($$v) {
            _vm.value = $$v
          },
          expression: "value",
        },
      }),
      _c(
        "article",
        {
          staticClass: "box setting-page-tile",
          staticStyle: { "overflow-x": "auto" },
        },
        [
          _c("div", [
            _c(
              "div",
              {
                staticClass:
                  "columns is-mobile is-justify-content-space-between",
              },
              [
                _c("div", { staticClass: "column is-narrow" }, [
                  _c("div", { staticClass: "columns" }, [
                    _c("div", { staticClass: "column" }, [
                      _c("div", { staticClass: "field is-horizontal" }, [
                        _vm._m(0),
                        _c("div", { staticClass: "field-body" }, [
                          _c("div", { staticClass: "field is-narrow" }, [
                            _c(
                              "p",
                              { staticClass: "control" },
                              [
                                _c("vue-numeric", {
                                  staticClass:
                                    "input has-text-right custom-setting",
                                  attrs: {
                                    min: 0,
                                    symbol: "$",
                                    precision: 2,
                                    disabled: !_vm.isBatchCanEdit,
                                  },
                                  model: {
                                    value: _vm.innerValue.perQuoteTotalMin,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.innerValue,
                                        "perQuoteTotalMin",
                                        $$v
                                      )
                                    },
                                    expression: "innerValue.perQuoteTotalMin",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]),
                        ]),
                      ]),
                    ]),
                    _c("div", { staticClass: "column" }, [
                      _c("div", { staticClass: "field is-horizontal" }, [
                        _vm._m(1),
                        _c("div", { staticClass: "field-body" }, [
                          _c("div", { staticClass: "field is-narrow" }, [
                            _c(
                              "p",
                              { staticClass: "control" },
                              [
                                _c("vue-numeric", {
                                  staticClass:
                                    "input has-text-right custom-setting",
                                  attrs: {
                                    min: 0,
                                    symbol: "$",
                                    precision: 2,
                                    disabled: !_vm.isBatchCanEdit,
                                  },
                                  model: {
                                    value: _vm.innerValue.perQuoteTotalMax,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.innerValue,
                                        "perQuoteTotalMax",
                                        $$v
                                      )
                                    },
                                    expression: "innerValue.perQuoteTotalMax",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]),
                        ]),
                      ]),
                    ]),
                  ]),
                ]),
                _c("div", { staticClass: "column is-narrow" }, [
                  _c("div", { staticClass: "columns" }, [
                    _c("div", { staticClass: "column is-narrow" }, [
                      _c("div", { staticClass: "field is-horizontal" }, [
                        _vm._m(2),
                        _c("div", { staticClass: "field-body" }, [
                          _c("div", { staticClass: "field is-narrow" }, [
                            _c(
                              "p",
                              { staticClass: "control" },
                              [
                                _c("vue-numeric", {
                                  staticClass:
                                    "input has-text-right custom-setting",
                                  attrs: {
                                    min: 0,
                                    symbol: "$",
                                    precision: 2,
                                    disabled: !_vm.isBatchCanEdit,
                                  },
                                  model: {
                                    value: _vm.innerValue.agreedArc,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.innerValue, "agreedArc", $$v)
                                    },
                                    expression: "innerValue.agreedArc",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]),
                        ]),
                      ]),
                    ]),
                  ]),
                ]),
                _c("div", { staticClass: "column is-narrow" }, [
                  _c("div", { staticClass: "columns" }, [
                    _c("div", { staticClass: "column" }, [
                      _c("div", { staticClass: "field is-horizontal" }, [
                        _vm._m(3),
                        _c("div", { staticClass: "field-body" }, [
                          _c("div", { staticClass: "field is-narrow" }, [
                            _c(
                              "p",
                              { staticClass: "control" },
                              [
                                _c("vue-numeric", {
                                  staticClass:
                                    "input has-text-right custom-setting",
                                  attrs: {
                                    min: 0,
                                    symbol: "$",
                                    precision: 2,
                                    disabled: !_vm.isBatchCanEdit,
                                  },
                                  model: {
                                    value: _vm.innerValue.alrLowerThreshold,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.innerValue,
                                        "alrLowerThreshold",
                                        $$v
                                      )
                                    },
                                    expression: "innerValue.alrLowerThreshold",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]),
                        ]),
                      ]),
                    ]),
                    _c("div", { staticClass: "column" }, [
                      _c("div", { staticClass: "field is-horizontal" }, [
                        _vm._m(4),
                        _c("div", { staticClass: "field-body" }, [
                          _c("div", { staticClass: "field is-narrow" }, [
                            _c(
                              "p",
                              { staticClass: "control" },
                              [
                                _c("vue-numeric", {
                                  staticClass:
                                    "input has-text-right custom-setting",
                                  attrs: {
                                    min: 0,
                                    symbol: "$",
                                    precision: 2,
                                    disabled: !_vm.isBatchCanEdit,
                                  },
                                  model: {
                                    value: _vm.innerValue.alrUpperThreshold,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.innerValue,
                                        "alrUpperThreshold",
                                        $$v
                                      )
                                    },
                                    expression: "innerValue.alrUpperThreshold",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]),
                        ]),
                      ]),
                    ]),
                  ]),
                ]),
              ]
            ),
          ]),
        ]
      ),
      _c("article", { staticClass: "box" }, [
        _c("div", { staticClass: "columns" }, [
          _c("div", { staticClass: "column" }, [
            _c("p", { staticClass: "title" }, [
              _c("span", { staticClass: "pr-1" }, [_vm._v("In Batch")]),
              _c("span", { staticClass: "has-text-primary" }, [
                _vm._v("(" + _vm._s(_vm.batchedQuotesTotalRows) + ")"),
              ]),
            ]),
          ]),
          _vm.isBatchCanEdit
            ? _c("div", { staticClass: "column is-narrow" }, [
                _c("div", { staticClass: "field is-narrow" }, [
                  _c(
                    "button",
                    {
                      staticClass: "button tooltip ml-5 button-remove",
                      attrs: {
                        "data-tooltip": "Remove Selected from Batch",
                        disabled: !_vm.batchedQuotes.length,
                      },
                      on: { click: _vm.removeRangeToBatch },
                    },
                    [_vm._v(" Remove from Batch ")]
                  ),
                ]),
              ])
            : _vm._e(),
          _c("div", { staticClass: "column is-narrow" }, [
            _c("div", { staticClass: "field is-narrow has-addons" }, [
              _c("div", { staticClass: "control has-icons-left" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.batchedQuotesQuery,
                      expression: "batchedQuotesQuery",
                    },
                  ],
                  staticClass: "input",
                  attrs: { type: "text", placeholder: "Quote No. or Rego" },
                  domProps: { value: _vm.batchedQuotesQuery },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.batchedQuotesQuery = $event.target.value
                    },
                  },
                }),
                _vm._m(5),
              ]),
              _c("div", { staticClass: "control" }, [
                _c(
                  "a",
                  {
                    staticClass: "button is-primary is-outlined tooltip",
                    attrs: { "data-tooltip": "Reset search" },
                    on: {
                      click: function ($event) {
                        _vm.batchedQuotesQuery = ""
                      },
                    },
                  },
                  [_vm._m(6)]
                ),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "column is-narrow pl-0" }, [
            _c(
              "button",
              {
                staticClass: "button tooltip is-success",
                attrs: {
                  "data-tooltip": "Download Excel",
                  disabled: !_vm.batchedQuotes.length,
                },
                on: {
                  click: function ($event) {
                    return _vm.exportToExcel(_vm.tableType.INBATCH)
                  },
                },
              },
              [
                _c("span", { staticClass: "msr msr-24px" }, [
                  _vm._v("file_save"),
                ]),
              ]
            ),
          ]),
        ]),
        _c("div", { staticClass: "field" }, [
          _c(
            "div",
            { staticClass: "table-container" },
            [
              _c(
                "bulma-table",
                {
                  ref: "batchedQuotesTable",
                  staticClass:
                    "table is-striped is-narrow is-fullwidth is-hoverable",
                  attrs: {
                    columns: _vm.batchingQuoteColumns,
                    "page-index": _vm.batchedQuotesFilter.pageIndex,
                    "page-size": _vm.batchedQuotesFilter.pageSize,
                    "total-rows": _vm.batchedQuotesTotalRows,
                    "is-loading": _vm.isBatchedQuotesTableLoading,
                    "sort-column": _vm.batchedQuotesFilter.sortColumn,
                    "sort-order": _vm.batchedQuotesFilter.sortOrder,
                    draggable: false,
                    "show-pagination": false,
                    "is-title-checkable": _vm.isBatchCanEdit,
                    "title-checkbox-location": "front",
                  },
                  on: {
                    sort: _vm.onBatchedQuotesSort,
                    "title-checkbox-changed": _vm.batchedCheckboxChanged,
                  },
                },
                [
                  _vm._l(_vm.filteredBatchedQuotes, function (quote, index) {
                    return _c(
                      "tr",
                      {
                        key: quote.quoteId,
                        on: {
                          click: function ($event) {
                            return _vm.highlightSelectedAvailableQuote(
                              index,
                              $event
                            )
                          },
                        },
                      },
                      [
                        _vm.isBatchCanEdit
                          ? _c(
                              "td",
                              {
                                staticClass:
                                  "has-vertical-middle has-text-centered",
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "pretty p-icon p-curve p-smooth m-0 p-bigger",
                                  },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: quote.isChecked,
                                          expression: "quote.isChecked",
                                        },
                                      ],
                                      attrs: { type: "checkbox" },
                                      domProps: {
                                        checked: Array.isArray(quote.isChecked)
                                          ? _vm._i(quote.isChecked, null) > -1
                                          : quote.isChecked,
                                      },
                                      on: {
                                        change: [
                                          function ($event) {
                                            var $$a = quote.isChecked,
                                              $$el = $event.target,
                                              $$c = $$el.checked ? true : false
                                            if (Array.isArray($$a)) {
                                              var $$v = null,
                                                $$i = _vm._i($$a, $$v)
                                              if ($$el.checked) {
                                                $$i < 0 &&
                                                  _vm.$set(
                                                    quote,
                                                    "isChecked",
                                                    $$a.concat([$$v])
                                                  )
                                              } else {
                                                $$i > -1 &&
                                                  _vm.$set(
                                                    quote,
                                                    "isChecked",
                                                    $$a
                                                      .slice(0, $$i)
                                                      .concat(
                                                        $$a.slice($$i + 1)
                                                      )
                                                  )
                                              }
                                            } else {
                                              _vm.$set(quote, "isChecked", $$c)
                                            }
                                          },
                                          _vm.handleBatchedCheckboxChange,
                                        ],
                                      },
                                    }),
                                    _c(
                                      "div",
                                      { staticClass: "state p-primary" },
                                      [
                                        _c("i", {
                                          staticClass: "icon mdi mdi-check",
                                        }),
                                        _c("label"),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            )
                          : _vm._e(),
                        _c("td", [
                          _c(
                            "a",
                            {
                              attrs: { href: "#" },
                              on: {
                                click: function ($event) {
                                  return _vm.viewQuote(quote.quoteId)
                                },
                              },
                            },
                            [_vm._v(_vm._s(quote.quoteNoRef))]
                          ),
                        ]),
                        _c("td", [_vm._v(_vm._s(quote.quoteStatus))]),
                        _c("td", [_vm._v(_vm._s(quote.jobStage))]),
                        _c("td", [_vm._v(_vm._s(quote.quoteStatusText))]),
                        _c("td", { staticClass: "has-text-right" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$filters.formatDateLocale(
                                quote.jobEnd,
                                _vm.$userInfo.locale
                              )
                            )
                          ),
                        ]),
                        _c("td", { staticClass: "has-text-centered" }, [
                          _vm._v(_vm._s(quote.daysElapsed)),
                        ]),
                        _c("td", [_vm._v(_vm._s(quote.claimNo))]),
                        _c("td", [_vm._v(_vm._s(quote.rego))]),
                        _c("td", [_vm._v(_vm._s(quote.fullName))]),
                        _c("td", [_vm._v(_vm._s(quote.insurer))]),
                        _c("td", { staticClass: "has-text-right" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$filters.formatCurrency(
                                quote.excess,
                                _vm.$userInfo.locale
                              )
                            )
                          ),
                        ]),
                        _c("td", { staticClass: "has-text-right" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$filters.formatNumberWithRounding(
                                quote.labourHour,
                                _vm.$userInfo.locale
                              )
                            )
                          ),
                        ]),
                        _c("td", { staticClass: "has-text-right" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$filters.formatCurrency(
                                quote.rate,
                                _vm.$userInfo.locale
                              )
                            )
                          ),
                        ]),
                        _c("td", { staticClass: "has-text-right" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$filters.formatCurrency(
                                quote.labourTotal,
                                _vm.$userInfo.locale
                              )
                            )
                          ),
                        ]),
                        _c("td", { staticClass: "has-text-right" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$filters.formatCurrency(
                                quote.partTotal,
                                _vm.$userInfo.locale
                              )
                            )
                          ),
                        ]),
                        _c("td", { staticClass: "has-text-right" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$filters.formatCurrency(
                                quote.subletTotal,
                                _vm.$userInfo.locale
                              )
                            )
                          ),
                        ]),
                        _c("td", { staticClass: "has-text-right" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$filters.formatCurrency(
                                quote.miscTotal,
                                _vm.$userInfo.locale
                              )
                            )
                          ),
                        ]),
                        _c("td", { staticClass: "has-text-right" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$filters.formatCurrency(
                                quote.totalExGST,
                                _vm.$userInfo.locale
                              )
                            )
                          ),
                        ]),
                        _c(
                          "td",
                          {
                            staticClass: "has-text-right",
                            class: {
                              "has-text-danger": _vm.delta(quote) < 0,
                              "has-text-success": _vm.delta(quote) >= 0,
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$filters.formatCurrency(
                                  _vm.delta(quote),
                                  _vm.$userInfo.locale
                                )
                              )
                            ),
                          ]
                        ),
                        _c("td", { staticClass: "has-text-centered col-1" }, [
                          _c(
                            "a",
                            {
                              staticClass:
                                "button is-dark is-small is-inverted",
                              on: {
                                mouseover: function ($event) {
                                  return _vm.getNotesContent(
                                    quote.isNoteExists,
                                    quote.quoteId
                                  )
                                },
                                mouseout: function ($event) {
                                  return _vm.resetNotesContent()
                                },
                                click: function ($event) {
                                  return _vm.notesClick(
                                    quote.quoteId,
                                    quote.quoteNoRef
                                  )
                                },
                              },
                            },
                            [
                              _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "tippy",
                                      rawName: "v-tippy",
                                      value: {
                                        enabled: _vm.showNoteContent,
                                        placement: "left-start",
                                        arrow: false,
                                        allowHTML: true,
                                      },
                                      expression:
                                        "{ enabled: showNoteContent, placement: 'left-start', arrow: false, allowHTML: true }",
                                    },
                                  ],
                                  staticClass: "icon is-medium",
                                  attrs: { content: _vm.notesContent },
                                },
                                [
                                  _c("i", {
                                    staticClass: "mdi mdi-24px",
                                    class: [
                                      quote.isNoteExists
                                        ? "mdi-note-edit has-text-warning"
                                        : "mdi-note-edit-outline has-text-grey",
                                    ],
                                  }),
                                ]
                              ),
                            ]
                          ),
                        ]),
                      ]
                    )
                  }),
                  _c("template", { slot: "empty" }, [
                    _c("section", { staticClass: "section" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "content has-text-grey has-text-centered",
                        },
                        [
                          _c("span", { attrs: { icon: "icon is-large" } }, [
                            _c("i", {
                              staticClass: "mdi mdi-48px mdi-emoticon-sad",
                            }),
                          ]),
                          _c("p", [_vm._v("Nothing")]),
                        ]
                      ),
                    ]),
                  ]),
                ],
                2
              ),
            ],
            1
          ),
        ]),
      ]),
      !_vm.isBatchCompleted
        ? _c("article", { staticClass: "box" }, [
            _c("div", { staticClass: "columns" }, [
              _c("div", { staticClass: "column" }, [
                _c("p", { staticClass: "title" }, [
                  _c("span", { staticClass: "pr-1" }, [
                    _vm._v("In Scope - Completed"),
                  ]),
                  _c("span", { staticClass: "has-text-primary" }, [
                    _vm._v("(" + _vm._s(_vm.inScopeQuotesTotalRows) + ")"),
                  ]),
                ]),
              ]),
              _vm.isBatchCanEdit
                ? _c("div", { staticClass: "column is-narrow" }, [
                    _c("div", { staticClass: "field is-narrow" }, [
                      _c(
                        "button",
                        {
                          staticClass: "button tooltip ml-5 button-add",
                          attrs: {
                            "data-tooltip": "Add Selected to Batch",
                            disabled: !_vm.inScopeQuotes.length,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.addRangeToBatch(_vm.tableType.INSCOPE)
                            },
                          },
                        },
                        [_vm._v(" Add to Batch ")]
                      ),
                    ]),
                  ])
                : _vm._e(),
              _c("div", { staticClass: "column is-narrow" }, [
                _c("div", { staticClass: "field is-narrow has-addons" }, [
                  _c("div", { staticClass: "control has-icons-left" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.inScopeQuotesQuery,
                          expression: "inScopeQuotesQuery",
                        },
                      ],
                      staticClass: "input",
                      attrs: { type: "text", placeholder: "Quote No. or Rego" },
                      domProps: { value: _vm.inScopeQuotesQuery },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.inScopeQuotesQuery = $event.target.value
                        },
                      },
                    }),
                    _vm._m(7),
                  ]),
                  _c("div", { staticClass: "control" }, [
                    _c(
                      "a",
                      {
                        staticClass: "button is-primary is-outlined tooltip",
                        attrs: { "data-tooltip": "Reset search" },
                        on: {
                          click: function ($event) {
                            _vm.inScopeQuotesQuery = ""
                          },
                        },
                      },
                      [_vm._m(8)]
                    ),
                  ]),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "field" }, [
              _c(
                "div",
                { staticClass: "table-container" },
                [
                  _c(
                    "bulma-table",
                    {
                      ref: "inScopeQuotesTable",
                      staticClass: "table is-striped is-narrow is-fullwidth",
                      attrs: {
                        columns: _vm.batchingQuoteColumns,
                        "page-index": _vm.inScopeQuotesFilter.pageIndex,
                        "page-size": _vm.inScopeQuotesFilter.pageSize,
                        "total-rows": _vm.inScopeQuotesTotalRows,
                        "is-loading": _vm.isInScopeQuotesTableLoading,
                        "sort-column": _vm.inScopeQuotesFilter.sortColumn,
                        "sort-order": _vm.inScopeQuotesFilter.sortOrder,
                        draggable: false,
                        "show-pagination": false,
                        "is-title-checkable": _vm.isBatchCanEdit,
                        "title-checkbox-location": "front",
                      },
                      on: {
                        sort: _vm.onInScopeQuotesSort,
                        "title-checkbox-changed": _vm.inScopeCheckboxChanged,
                      },
                    },
                    [
                      _vm._l(
                        _vm.filteredInScopeQuotes,
                        function (quote, index) {
                          return _c(
                            "tr",
                            {
                              key: quote.quoteId,
                              on: {
                                click: function ($event) {
                                  return _vm.highlightSelectedAvailableQuote(
                                    index,
                                    $event
                                  )
                                },
                              },
                            },
                            [
                              _vm.isBatchCanEdit
                                ? _c(
                                    "td",
                                    {
                                      staticClass:
                                        "has-vertical-middle has-text-centered",
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "pretty p-icon p-curve p-smooth m-0 p-bigger",
                                        },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: quote.isChecked,
                                                expression: "quote.isChecked",
                                              },
                                            ],
                                            attrs: { type: "checkbox" },
                                            domProps: {
                                              checked: Array.isArray(
                                                quote.isChecked
                                              )
                                                ? _vm._i(
                                                    quote.isChecked,
                                                    null
                                                  ) > -1
                                                : quote.isChecked,
                                            },
                                            on: {
                                              change: [
                                                function ($event) {
                                                  var $$a = quote.isChecked,
                                                    $$el = $event.target,
                                                    $$c = $$el.checked
                                                      ? true
                                                      : false
                                                  if (Array.isArray($$a)) {
                                                    var $$v = null,
                                                      $$i = _vm._i($$a, $$v)
                                                    if ($$el.checked) {
                                                      $$i < 0 &&
                                                        _vm.$set(
                                                          quote,
                                                          "isChecked",
                                                          $$a.concat([$$v])
                                                        )
                                                    } else {
                                                      $$i > -1 &&
                                                        _vm.$set(
                                                          quote,
                                                          "isChecked",
                                                          $$a
                                                            .slice(0, $$i)
                                                            .concat(
                                                              $$a.slice($$i + 1)
                                                            )
                                                        )
                                                    }
                                                  } else {
                                                    _vm.$set(
                                                      quote,
                                                      "isChecked",
                                                      $$c
                                                    )
                                                  }
                                                },
                                                _vm.handleInScopeCheckboxChange,
                                              ],
                                            },
                                          }),
                                          _c(
                                            "div",
                                            { staticClass: "state p-primary" },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "icon mdi mdi-check",
                                              }),
                                              _c("label"),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _c("td", [
                                _c(
                                  "a",
                                  {
                                    attrs: { href: "#" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.viewQuote(quote.quoteId)
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(quote.quoteNoRef))]
                                ),
                              ]),
                              _c("td", [_vm._v(_vm._s(quote.quoteStatus))]),
                              _c("td", [_vm._v(_vm._s(quote.jobStage))]),
                              _c("td", [_vm._v(_vm._s(quote.quoteStatusText))]),
                              _c("td", { staticClass: "has-text-right" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$filters.formatDateLocale(
                                      quote.jobEnd,
                                      _vm.$userInfo.locale
                                    )
                                  )
                                ),
                              ]),
                              _c("td", { staticClass: "has-text-centered" }, [
                                _vm._v(_vm._s(quote.daysElapsed)),
                              ]),
                              _c("td", [_vm._v(_vm._s(quote.claimNo))]),
                              _c("td", [_vm._v(_vm._s(quote.rego))]),
                              _c("td", [_vm._v(_vm._s(quote.fullName))]),
                              _c("td", [_vm._v(_vm._s(quote.insurer))]),
                              _c("td", { staticClass: "has-text-right" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$filters.formatCurrency(
                                      quote.excess,
                                      _vm.$userInfo.locale
                                    )
                                  )
                                ),
                              ]),
                              _c("td", { staticClass: "has-text-right" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$filters.formatNumberWithRounding(
                                      quote.labourHour,
                                      _vm.$userInfo.locale
                                    )
                                  )
                                ),
                              ]),
                              _c("td", { staticClass: "has-text-right" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$filters.formatCurrency(
                                      quote.rate,
                                      _vm.$userInfo.locale
                                    )
                                  )
                                ),
                              ]),
                              _c("td", { staticClass: "has-text-right" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$filters.formatCurrency(
                                      quote.labourTotal,
                                      _vm.$userInfo.locale
                                    )
                                  )
                                ),
                              ]),
                              _c("td", { staticClass: "has-text-right" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$filters.formatCurrency(
                                      quote.partTotal,
                                      _vm.$userInfo.locale
                                    )
                                  )
                                ),
                              ]),
                              _c("td", { staticClass: "has-text-right" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$filters.formatCurrency(
                                      quote.subletTotal,
                                      _vm.$userInfo.locale
                                    )
                                  )
                                ),
                              ]),
                              _c("td", { staticClass: "has-text-right" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$filters.formatCurrency(
                                      quote.miscTotal,
                                      _vm.$userInfo.locale
                                    )
                                  )
                                ),
                              ]),
                              _c("td", { staticClass: "has-text-right" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$filters.formatCurrency(
                                      quote.totalExGST,
                                      _vm.$userInfo.locale
                                    )
                                  )
                                ),
                              ]),
                              _c(
                                "td",
                                {
                                  staticClass: "has-text-right",
                                  class: {
                                    "has-text-danger": _vm.delta(quote) < 0,
                                    "has-text-success": _vm.delta(quote) >= 0,
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$filters.formatCurrency(
                                        _vm.delta(quote),
                                        _vm.$userInfo.locale
                                      )
                                    )
                                  ),
                                ]
                              ),
                              _c(
                                "td",
                                { staticClass: "has-text-centered col-1" },
                                [
                                  _c(
                                    "a",
                                    {
                                      staticClass:
                                        "button is-dark is-small is-inverted",
                                      on: {
                                        mouseover: function ($event) {
                                          return _vm.getNotesContent(
                                            quote.isNoteExists,
                                            quote.quoteId
                                          )
                                        },
                                        mouseout: function ($event) {
                                          return _vm.resetNotesContent()
                                        },
                                        click: function ($event) {
                                          return _vm.notesClick(
                                            quote.quoteId,
                                            quote.quoteNoRef
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          directives: [
                                            {
                                              name: "tippy",
                                              rawName: "v-tippy",
                                              value: {
                                                enabled: _vm.showNoteContent,
                                                placement: "left-start",
                                                arrow: false,
                                                allowHTML: true,
                                              },
                                              expression:
                                                "{ enabled: showNoteContent, placement: 'left-start', arrow: false, allowHTML: true }",
                                            },
                                          ],
                                          staticClass: "icon is-medium",
                                          attrs: { content: _vm.notesContent },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "mdi mdi-24px",
                                            class: [
                                              quote.isNoteExists
                                                ? "mdi-note-edit has-text-warning"
                                                : "mdi-note-edit-outline has-text-grey",
                                            ],
                                          }),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          )
                        }
                      ),
                      _c("template", { slot: "empty" }, [
                        _c("section", { staticClass: "section" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "content has-text-grey has-text-centered",
                            },
                            [
                              _c("span", { attrs: { icon: "icon is-large" } }, [
                                _c("i", {
                                  staticClass: "mdi mdi-48px mdi-emoticon-sad",
                                }),
                              ]),
                              _c("p", [_vm._v("Nothing")]),
                            ]
                          ),
                        ]),
                      ]),
                    ],
                    2
                  ),
                ],
                1
              ),
            ]),
          ])
        : _vm._e(),
      !_vm.isBatchCompleted
        ? _c("article", { staticClass: "box" }, [
            _c("div", { staticClass: "columns" }, [
              _c("div", { staticClass: "column" }, [
                _c("p", { staticClass: "title" }, [
                  _c("span", { staticClass: "pr-1" }, [
                    _vm._v("In Scope - In Progress"),
                  ]),
                  _c("span", { staticClass: "has-text-primary mr-3" }, [
                    _vm._v("(" + _vm._s(_vm.inProgressQuotesTotalRows) + ")"),
                  ]),
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.$filters.formatCurrency(
                          _vm.inProgressQuotesAvgCost,
                          _vm.$userInfo.locale
                        )
                      )
                    ),
                  ]),
                ]),
              ]),
              _c("div", { staticClass: "column is-narrow" }, [
                _c("div", { staticClass: "field is-narrow has-addons" }, [
                  _c("div", { staticClass: "control has-icons-left" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.inProgressQuotesQuery,
                          expression: "inProgressQuotesQuery",
                        },
                      ],
                      staticClass: "input",
                      attrs: { type: "text", placeholder: "Quote No. or Rego" },
                      domProps: { value: _vm.inProgressQuotesQuery },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.inProgressQuotesQuery = $event.target.value
                        },
                      },
                    }),
                    _vm._m(9),
                  ]),
                  _c("div", { staticClass: "control" }, [
                    _c(
                      "a",
                      {
                        staticClass: "button is-primary is-outlined tooltip",
                        attrs: { "data-tooltip": "Reset search" },
                        on: {
                          click: function ($event) {
                            _vm.inProgressQuotesQuery = ""
                          },
                        },
                      },
                      [_vm._m(10)]
                    ),
                  ]),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "field" }, [
              _c(
                "div",
                { staticClass: "table-container" },
                [
                  _c(
                    "bulma-table",
                    {
                      ref: "inProgressQuotesTable",
                      staticClass: "table is-striped is-narrow is-fullwidth",
                      attrs: {
                        columns: _vm.batchingQuoteColumns,
                        "page-index": _vm.inProgressQuotesFilter.pageIndex,
                        "page-size": _vm.inProgressQuotesFilter.pageSize,
                        "total-rows": _vm.inProgressQuotesTotalRows,
                        "is-loading": _vm.isInProgressQuotesTableLoading,
                        "sort-column": _vm.inProgressQuotesFilter.sortColumn,
                        "sort-order": _vm.inProgressQuotesFilter.sortOrder,
                        draggable: false,
                        "show-pagination": false,
                        "is-title-checkable": false,
                        "title-checkbox-location": "front",
                      },
                      on: {
                        sort: _vm.onInProgressQuotesSort,
                        "title-checkbox-changed": _vm.inProgressCheckboxChanged,
                      },
                    },
                    [
                      _vm._l(
                        _vm.filteredInProgressQuotes,
                        function (quote, index) {
                          return _c(
                            "tr",
                            {
                              key: quote.quoteId,
                              class: {
                                ["orm-batching-background-danger-" +
                                _vm.$theme.name]: _vm.isRowHighlighted(quote),
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.highlightSelectedAvailableQuote(
                                    index,
                                    $event
                                  )
                                },
                              },
                            },
                            [
                              _c("td", [
                                _c(
                                  "a",
                                  {
                                    attrs: { href: "#" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.viewQuote(quote.quoteId)
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(quote.quoteNoRef))]
                                ),
                              ]),
                              _c("td", [_vm._v(_vm._s(quote.quoteStatus))]),
                              _c("td", [_vm._v(_vm._s(quote.jobStage))]),
                              _c("td", [_vm._v(_vm._s(quote.quoteStatusText))]),
                              _c("td", { staticClass: "has-text-right" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$filters.formatDateLocale(
                                      quote.jobEnd,
                                      _vm.$userInfo.locale
                                    )
                                  )
                                ),
                              ]),
                              _c("td", { staticClass: "has-text-centered" }, [
                                _vm._v(_vm._s(quote.daysElapsed)),
                              ]),
                              _c("td", [_vm._v(_vm._s(quote.claimNo))]),
                              _c("td", [_vm._v(_vm._s(quote.rego))]),
                              _c("td", [_vm._v(_vm._s(quote.fullName))]),
                              _c("td", [_vm._v(_vm._s(quote.insurer))]),
                              _c("td", { staticClass: "has-text-right" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$filters.formatCurrency(
                                      quote.excess,
                                      _vm.$userInfo.locale
                                    )
                                  )
                                ),
                              ]),
                              _c("td", { staticClass: "has-text-right" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$filters.formatNumberWithRounding(
                                      quote.labourHour,
                                      _vm.$userInfo.locale
                                    )
                                  )
                                ),
                              ]),
                              _c("td", { staticClass: "has-text-right" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$filters.formatCurrency(
                                      quote.rate,
                                      _vm.$userInfo.locale
                                    )
                                  )
                                ),
                              ]),
                              _c("td", { staticClass: "has-text-right" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$filters.formatCurrency(
                                      quote.labourTotal,
                                      _vm.$userInfo.locale
                                    )
                                  )
                                ),
                              ]),
                              _c("td", { staticClass: "has-text-right" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$filters.formatCurrency(
                                      quote.partTotal,
                                      _vm.$userInfo.locale
                                    )
                                  )
                                ),
                              ]),
                              _c("td", { staticClass: "has-text-right" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$filters.formatCurrency(
                                      quote.subletTotal,
                                      _vm.$userInfo.locale
                                    )
                                  )
                                ),
                              ]),
                              _c("td", { staticClass: "has-text-right" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$filters.formatCurrency(
                                      quote.miscTotal,
                                      _vm.$userInfo.locale
                                    )
                                  )
                                ),
                              ]),
                              _c("td", { staticClass: "has-text-right" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$filters.formatCurrency(
                                      quote.totalExGST,
                                      _vm.$userInfo.locale
                                    )
                                  )
                                ),
                              ]),
                              _c(
                                "td",
                                {
                                  staticClass: "has-text-right",
                                  class: {
                                    "has-text-danger": _vm.delta(quote) < 0,
                                    "has-text-success": _vm.delta(quote) >= 0,
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$filters.formatCurrency(
                                        _vm.delta(quote),
                                        _vm.$userInfo.locale
                                      )
                                    )
                                  ),
                                ]
                              ),
                              _c(
                                "td",
                                { staticClass: "has-text-centered col-1" },
                                [
                                  _c(
                                    "a",
                                    {
                                      staticClass:
                                        "button is-dark is-small is-inverted",
                                      on: {
                                        mouseover: function ($event) {
                                          return _vm.getNotesContent(
                                            quote.isNoteExists,
                                            quote.quoteId
                                          )
                                        },
                                        mouseout: function ($event) {
                                          return _vm.resetNotesContent()
                                        },
                                        click: function ($event) {
                                          return _vm.notesClick(
                                            quote.quoteId,
                                            quote.quoteNoRef
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          directives: [
                                            {
                                              name: "tippy",
                                              rawName: "v-tippy",
                                              value: {
                                                enabled: _vm.showNoteContent,
                                                placement: "left-start",
                                                arrow: false,
                                                allowHTML: true,
                                              },
                                              expression:
                                                "{ enabled: showNoteContent, placement: 'left-start', arrow: false, allowHTML: true }",
                                            },
                                          ],
                                          staticClass: "icon is-medium",
                                          attrs: { content: _vm.notesContent },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "mdi mdi-24px",
                                            class: [
                                              quote.isNoteExists
                                                ? "mdi-note-edit has-text-warning"
                                                : "mdi-note-edit-outline has-text-grey",
                                            ],
                                          }),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          )
                        }
                      ),
                      _c("template", { slot: "empty" }, [
                        _c("section", { staticClass: "section" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "content has-text-grey has-text-centered",
                            },
                            [
                              _c("span", { attrs: { icon: "icon is-large" } }, [
                                _c("i", {
                                  staticClass: "mdi mdi-48px mdi-emoticon-sad",
                                }),
                              ]),
                              _c("p", [_vm._v("Nothing")]),
                            ]
                          ),
                        ]),
                      ]),
                    ],
                    2
                  ),
                ],
                1
              ),
            ]),
          ])
        : _vm._e(),
      !_vm.isBatchCompleted
        ? _c("article", { staticClass: "box" }, [
            _c("div", { staticClass: "columns" }, [
              _c("div", { staticClass: "column" }, [
                _c("p", { staticClass: "title" }, [
                  _c("span", { staticClass: "pr-1" }, [_vm._v("Out of Scope")]),
                  _c("span", { staticClass: "has-text-primary" }, [
                    _vm._v("(" + _vm._s(_vm.outScopeQuotesTotalRows) + ")"),
                  ]),
                ]),
              ]),
              _c("div", { staticClass: "column is-narrow" }, [
                _c("div", { staticClass: "field is-narrow has-addons" }, [
                  _c("div", { staticClass: "control has-icons-left" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.outScopeQuotesQuery,
                          expression: "outScopeQuotesQuery",
                        },
                      ],
                      staticClass: "input",
                      attrs: { type: "text", placeholder: "Quote No. or Rego" },
                      domProps: { value: _vm.outScopeQuotesQuery },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.outScopeQuotesQuery = $event.target.value
                        },
                      },
                    }),
                    _vm._m(11),
                  ]),
                  _c("div", { staticClass: "control" }, [
                    _c(
                      "a",
                      {
                        staticClass: "button is-primary is-outlined tooltip",
                        attrs: { "data-tooltip": "Reset search" },
                        on: {
                          click: function ($event) {
                            _vm.outScopeQuotesQuery = ""
                          },
                        },
                      },
                      [_vm._m(12)]
                    ),
                  ]),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "field" }, [
              _c(
                "div",
                { staticClass: "table-container" },
                [
                  _c(
                    "bulma-table",
                    {
                      ref: "outScopeQuotesTable",
                      staticClass: "table is-striped is-narrow is-fullwidth",
                      attrs: {
                        columns: _vm.batchingQuoteColumns,
                        "page-index": _vm.outScopeQuotesFilter.pageIndex,
                        "page-size": _vm.outScopeQuotesFilter.pageSize,
                        "total-rows": _vm.outScopeQuotesTotalRows,
                        "is-loading": _vm.isOutScopeQuotesTableLoading,
                        "sort-column": _vm.outScopeQuotesFilter.sortColumn,
                        "sort-order": _vm.outScopeQuotesFilter.sortOrder,
                        draggable: false,
                        "show-pagination": false,
                      },
                      on: { sort: _vm.onOutScopeQuotesSort },
                    },
                    [
                      _vm._l(
                        _vm.filteredOutScopeQuotes,
                        function (quote, index) {
                          return _c(
                            "tr",
                            {
                              key: quote.quoteId,
                              class: {
                                ["orm-batching-background-danger-" +
                                _vm.$theme.name]: _vm.isRowHighlighted(quote),
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.highlightSelectedAvailableQuote(
                                    index,
                                    $event
                                  )
                                },
                              },
                            },
                            [
                              _c("td", [
                                _c(
                                  "a",
                                  {
                                    attrs: { href: "#" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.viewQuote(quote.quoteId)
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(quote.quoteNoRef))]
                                ),
                              ]),
                              _c("td", [_vm._v(_vm._s(quote.quoteStatus))]),
                              _c("td", [_vm._v(_vm._s(quote.jobStage))]),
                              _c("td", [_vm._v(_vm._s(quote.quoteStatusText))]),
                              _c("td", { staticClass: "has-text-right" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$filters.formatDateLocale(
                                      quote.jobEnd,
                                      _vm.$userInfo.locale
                                    )
                                  )
                                ),
                              ]),
                              _c("td", { staticClass: "has-text-centered" }, [
                                _vm._v(_vm._s(quote.daysElapsed)),
                              ]),
                              _c("td", [_vm._v(_vm._s(quote.claimNo))]),
                              _c("td", [_vm._v(_vm._s(quote.rego))]),
                              _c("td", [_vm._v(_vm._s(quote.fullName))]),
                              _c("td", [_vm._v(_vm._s(quote.insurer))]),
                              _c("td", { staticClass: "has-text-right" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$filters.formatCurrency(
                                      quote.excess,
                                      _vm.$userInfo.locale
                                    )
                                  )
                                ),
                              ]),
                              _c("td", { staticClass: "has-text-right" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$filters.formatNumberWithRounding(
                                      quote.labourHour,
                                      _vm.$userInfo.locale
                                    )
                                  )
                                ),
                              ]),
                              _c("td", { staticClass: "has-text-right" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$filters.formatCurrency(
                                      quote.rate,
                                      _vm.$userInfo.locale
                                    )
                                  )
                                ),
                              ]),
                              _c("td", { staticClass: "has-text-right" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$filters.formatCurrency(
                                      quote.labourTotal,
                                      _vm.$userInfo.locale
                                    )
                                  )
                                ),
                              ]),
                              _c("td", { staticClass: "has-text-right" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$filters.formatCurrency(
                                      quote.partTotal,
                                      _vm.$userInfo.locale
                                    )
                                  )
                                ),
                              ]),
                              _c("td", { staticClass: "has-text-right" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$filters.formatCurrency(
                                      quote.subletTotal,
                                      _vm.$userInfo.locale
                                    )
                                  )
                                ),
                              ]),
                              _c("td", { staticClass: "has-text-right" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$filters.formatCurrency(
                                      quote.miscTotal,
                                      _vm.$userInfo.locale
                                    )
                                  )
                                ),
                              ]),
                              _c("td", { staticClass: "has-text-right" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$filters.formatCurrency(
                                      quote.totalExGST,
                                      _vm.$userInfo.locale
                                    )
                                  )
                                ),
                              ]),
                              _c(
                                "td",
                                {
                                  staticClass: "has-text-right",
                                  class: {
                                    "has-text-danger": _vm.delta(quote) < 0,
                                    "has-text-success": _vm.delta(quote) >= 0,
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$filters.formatCurrency(
                                        _vm.delta(quote),
                                        _vm.$userInfo.locale
                                      )
                                    )
                                  ),
                                ]
                              ),
                              _c(
                                "td",
                                { staticClass: "has-text-centered col-1" },
                                [
                                  _c(
                                    "a",
                                    {
                                      staticClass:
                                        "button is-dark is-small is-inverted",
                                      on: {
                                        mouseover: function ($event) {
                                          return _vm.getNotesContent(
                                            quote.isNoteExists,
                                            quote.quoteId
                                          )
                                        },
                                        mouseout: function ($event) {
                                          return _vm.resetNotesContent()
                                        },
                                        click: function ($event) {
                                          return _vm.notesClick(
                                            quote.quoteId,
                                            quote.quoteNoRef
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          directives: [
                                            {
                                              name: "tippy",
                                              rawName: "v-tippy",
                                              value: {
                                                enabled: _vm.showNoteContent,
                                                placement: "left-start",
                                                arrow: false,
                                                allowHTML: true,
                                              },
                                              expression:
                                                "{ enabled: showNoteContent, placement: 'left-start', arrow: false, allowHTML: true }",
                                            },
                                          ],
                                          staticClass: "icon is-medium",
                                          attrs: { content: _vm.notesContent },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "mdi mdi-24px",
                                            class: [
                                              quote.isNoteExists
                                                ? "mdi-note-edit has-text-warning"
                                                : "mdi-note-edit-outline has-text-grey",
                                            ],
                                          }),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          )
                        }
                      ),
                      _c("template", { slot: "empty" }, [
                        _c("section", { staticClass: "section" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "content has-text-grey has-text-centered",
                            },
                            [
                              _c("span", { attrs: { icon: "icon is-large" } }, [
                                _c("i", {
                                  staticClass: "mdi mdi-48px mdi-emoticon-sad",
                                }),
                              ]),
                              _c("p", [_vm._v("Nothing")]),
                            ]
                          ),
                        ]),
                      ]),
                    ],
                    2
                  ),
                ],
                1
              ),
            ]),
          ])
        : _vm._e(),
      _c("div", { ref: "notesList", staticClass: "is-hidden" }, [
        _c(
          "ul",
          {
            staticStyle: { "list-style-type": "disc", "padding-left": "1rem" },
          },
          _vm._l(_vm.notes, function (note, index) {
            return _c("li", { key: index }, [
              _c("span", { staticClass: "is-size-6" }, [
                _vm._v(_vm._s(note.remarks)),
              ]),
              _c(
                "div",
                { staticClass: "is-flex is-align-items-center is-size-7" },
                [
                  note.firstName || note.displayName
                    ? _c("user-profile-icon", {
                        staticClass: "pr-1",
                        attrs: {
                          "is-text-profile": true,
                          "first-name": note.firstName,
                          "last-name": note.lastName,
                          "display-name": note.displayName,
                          width: 20,
                          height: 20,
                        },
                      })
                    : _vm._e(),
                  _c("span", { staticClass: "help is-italic has-text-grey" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$filters.formatDateTimeLocale(
                          note.remarkDateTime,
                          _vm.$userInfo.locale
                        )
                      )
                    ),
                  ]),
                ],
                1
              ),
            ])
          }),
          0
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass:
          "field-label is-narrow is-flex is-align-items-center is-justify-content-center",
      },
      [
        _c("label", { staticClass: "label has-text-nowrap" }, [
          _vm._v("Total Val (ex GST)"),
        ]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass:
          "field-label is-narrow is-flex is-align-items-center is-justify-content-center",
      },
      [_c("label", { staticClass: "label has-text-nowrap" }, [_vm._v("to")])]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass:
          "field-label is-narrow is-flex is-align-items-center is-justify-content-center",
      },
      [
        _c("label", { staticClass: "label has-text-nowrap" }, [
          _vm._v("Avg Target Cost"),
        ]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass:
          "field-label is-narrow is-flex is-align-items-center is-justify-content-center",
      },
      [
        _c("label", { staticClass: "label has-text-nowrap" }, [
          _vm._v("ALR L. Threshold"),
        ]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass:
          "field-label is-narrow is-flex is-align-items-center is-justify-content-center",
      },
      [
        _c("label", { staticClass: "label has-text-nowrap" }, [
          _vm._v("ALR U. Threshold"),
        ]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon is-left" }, [
      _c("i", { staticClass: "mdi mdi-magnify mdi-24px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-close mdi-24px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon is-left" }, [
      _c("i", { staticClass: "mdi mdi-magnify mdi-24px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-close mdi-24px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon is-left" }, [
      _c("i", { staticClass: "mdi mdi-magnify mdi-24px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-close mdi-24px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon is-left" }, [
      _c("i", { staticClass: "mdi mdi-magnify mdi-24px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-close mdi-24px" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }